// src/components/CountdownSection.jsx
import React from 'react';
import Countdown from 'react-countdown';
import './CountdownSection.css';
import summitBg from '../assets/images/summit.jpeg';

const CountdownSection = () => {
  // Summit date: 4th August 2026
  const summitDate = new Date('2026-11-26T00:00:00');

  const renderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
      return <div className="countdown-completed">The Summit Has Begun!</div>;
    } else {
      return (
        <div className="countdown-grid">
          <div className="countdown-item">
            <span className="countdown-number">{days}</span>
            <span className="countdown-label">Days</span>
          </div>
          <div className="countdown-divider">:</div>
          <div className="countdown-item">
            <span className="countdown-number">{hours}</span>
            <span className="countdown-label">Hours</span>
          </div>
          <div className="countdown-divider">:</div>
          <div className="countdown-item">
            <span className="countdown-number">{minutes}</span>
            <span className="countdown-label">Minutes</span>
          </div>
          <div className="countdown-divider">:</div>
          <div className="countdown-item">
            <span className="countdown-number">{seconds}</span>
            <span className="countdown-label">Seconds</span>
          </div>
        </div>
      );
    }
  };

  return (
    <section 
      className="countdown-section"
      style={{ 
        backgroundImage: `url(${summitBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed'
      }}
    >
      <div className="countdown-overlay"></div>
      <div className="countdown-container">
        <div className="countdown-header">
          <span className="countdown-badge">COUNTDOWN TO SUMMIT</span>
          <h2 className="countdown-title">AICIS GLOBAL SUMMIT 2026</h2>
          <p className="countdown-subtitle">25 - 28 November 2026 • Abuja, Nigeria</p>
        </div>
        <Countdown date={summitDate} renderer={renderer} />
        <div className="countdown-location-info">
          <div className="location-detail">
            <span className="location-icon">🏛️</span>
            <span>Presidential Opening: Aso Rock Villa</span>
          </div>
          <div className="location-detail">
            <span className="location-icon">🏢</span>
            <span>Technical Sessions: Transcorp Hilton & Afreximbank AATC</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CountdownSection;